/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';
import { Component, HostBinding, Input } from '@angular/core';
import { cva, VariantProps } from 'class-variance-authority';
import { UserIconComponent } from '../user-icon/user-icon.component';
import { UserProfileResource } from '../user-profile.model';
import { UserProfileNameComponent } from '../user-profile-name/user-profile-name.component';

export const userProfileVariants = cva('flex min-w-0 items-center', {
  variants: {
    variant: {
      search: 'gap-2',
      searchResult: 'gap-2 py-2 px-4',
    },
  },
});
export type UserProfileVariants = VariantProps<typeof userProfileVariants>;

@Component({
  selector: 'alfa-user-profile',
  templateUrl: './user-profile.component.html',
  standalone: true,
  imports: [UserIconComponent, UserProfileNameComponent],
})
export class UserProfileComponent {
  @Input() variant: UserProfileVariants['variant'];
  @Input() userProfileStateResource: StateResource<UserProfileResource>;

  @HostBinding('class') get hostClasses() {
    return userProfileVariants({ variant: this.variant });
  }
}
